import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import ClaimWizard from "@/pages/ClaimWizard";
import SelfPayer from "@/pages/SelfPayer";
import StatusPage from "@/pages/StatusPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminTint from "@/pages/AdminTint";
import AdminSattlerei from "@/pages/AdminSattlerei";
import Toenung from "@/pages/Toenung";
import Sattlerei from "@/pages/Sattlerei";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEmails from "@/pages/AdminEmails";
import NotFound from "@/pages/NotFound";
import SchnellCheck from "@/pages/SchnellCheck";
import AdminClaimDetail from "@/pages/AdminClaimDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AGB from "@/pages/AGB";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import CookieHinweis from "@/pages/CookieHinweis";
import Widerruf from "@/pages/Widerruf";
import LeistungenHub from "@/pages/info/LeistungenHub";
import LeistungPage from "@/pages/info/LeistungPage";
import StadtPage from "@/pages/info/StadtPage";
import VersicherungenHub from "@/pages/info/VersicherungenHub";
import VersicherungPage from "@/pages/info/VersicherungPage";
import FAQPage from "@/pages/info/FAQPage";
import DedicatedLanding from "@/pages/info/DedicatedLanding";
import SattlereiRatgeberPage from "@/pages/info/SattlereiRatgeberPage";
import Chatbot from "@/components/Chatbot";
import CookieConsent from "@/components/CookieConsent";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/schaden-melden" element={<ClaimWizard />} />
            <Route path="/schaden-melden/:claimId" element={<ClaimWizard />} />
            <Route path="/selbstzahler" element={<SelfPayer />} />
            <Route path="/selbstzahler/:claimId" element={<SelfPayer />} />
            <Route path="/status" element={<StatusPage />} />
            <Route path="/status/:trackingCode" element={<StatusPage />} />
            <Route path="/zahlung-erfolg" element={<PaymentSuccess />} />

            {/* SEO Content */}
            <Route path="/leistungen" element={<LeistungenHub />} />
            <Route path="/leistung/:serviceSlug" element={<LeistungPage />} />
            <Route path="/standort/:citySlug" element={<StadtPage />} />
            <Route path="/versicherungen" element={<VersicherungenHub />} />
            <Route path="/versicherung/:insuranceSlug" element={<VersicherungPage />} />
            <Route path="/faq" element={<FAQPage />} />

            {/* Dedicated SEO Landing Pages */}
            <Route path="/autoglas-mannheim" element={<DedicatedLanding />} />
            <Route path="/autoglas-ludwigshafen" element={<DedicatedLanding />} />
            <Route path="/steinschlagreparatur-mannheim" element={<DedicatedLanding />} />
            <Route path="/windschutzscheibe-mannheim" element={<DedicatedLanding />} />
            <Route path="/scheibentoenung-mannheim" element={<DedicatedLanding />} />
            <Route path="/sattlerei-mannheim" element={<DedicatedLanding />} />
            <Route path="/sattlerei-heidelberg" element={<DedicatedLanding />} />
            <Route path="/sattlerei-speyer" element={<DedicatedLanding />} />
            <Route path="/scheibentoenung" element={<Toenung />} />
            <Route path="/sattlerei" element={<Sattlerei />} />
            <Route path="/sattlerei/:ratgeberSlug" element={<SattlereiRatgeberPage />} />
            <Route path="/steinschlagreparatur-ludwigshafen" element={<DedicatedLanding />} />
            <Route path="/windschutzscheibe-ludwigshafen" element={<DedicatedLanding />} />
            <Route path="/autoglas-muenchen" element={<DedicatedLanding />} />
            <Route path="/steinschlagreparatur-muenchen" element={<DedicatedLanding />} />
            <Route path="/windschutzscheibe-muenchen" element={<DedicatedLanding />} />

            {/* Legal */}
            <Route path="/agb" element={<AGB />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/cookie" element={<CookieHinweis />} />
            <Route path="/widerruf" element={<Widerruf />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/emails" element={<AdminEmails />} />
            <Route path="/admin/toenung" element={<AdminTint />} />
            <Route path="/admin/sattlerei" element={<AdminSattlerei />} />
            <Route path="/admin/claims/:claimId" element={<AdminClaimDetail />} />
            <Route path="/schnell-check" element={<SchnellCheck />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Chatbot />
          <CookieConsent />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
